function getPbxxId() {
  const pbxxId =
    localStorage.getItem('pbxxId') ||
    Math.random().toString(36).substring(2, 15)
  localStorage.setItem('pbxxId', pbxxId)

  return pbxxId
}

export default getPbxxId
